import { FC } from "react";
import { Button } from "src/atoms/Button";
import { useAddProductsToCollection } from "src/hooks/useAddProductToCollection";
import { useAddProductsToStorefront } from "src/hooks/useAddProductToStorefront";

interface Props {
  close: () => void;
  selectedCollection: string;
  shouldAddToStorefront: boolean;
  shouldAddToCollection: boolean;
  productsIds: number[];
}

const SaveCollectionButton: FC<Props> = ({
  close,
  selectedCollection,
  shouldAddToStorefront,
  shouldAddToCollection,
  productsIds,
}) => {
  const { addProductsToCollection, loading: addToCollectionLoading } =
    useAddProductsToCollection();
  const { addProductsToStorefront, loading: addToStorefrontLoading } =
    useAddProductsToStorefront();

  const save = async () => {
    if (shouldAddToCollection) {
      await addProductsToCollection(selectedCollection, productsIds);
    }

    if (shouldAddToStorefront) {
      await addProductsToStorefront(selectedCollection, productsIds);
    }

    close();
  };

  return (
    <Button
      variant="primary"
      disabled={!shouldAddToCollection && !shouldAddToStorefront}
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onClick={save}
      loading={addToCollectionLoading || addToStorefrontLoading}
    >
      Save
    </Button>
  );
};

export default SaveCollectionButton;
